import type { ISdkModel } from '../../store-manager';
import type { ImageBlobAndString } from '../image-prepare-plugin';
import BasePrepareModel from './base-prepare-model';

class DefaultPrepareModel extends BasePrepareModel {
    public getHtml(data: ISdkModel, imageBlobAndString?: ImageBlobAndString): string {
        if (imageBlobAndString?.imgStr) {
            return this.containerTagIsImage(data, imageBlobAndString.imgStr);
        }
        const containerTag = document.createElement('div');
        this.insertPrivateData(containerTag, data);
        // 这里创建一个占位符。没有占位符剪贴板写不进去。
        const p = document.createElement('p');
        containerTag.appendChild(p);
        return containerTag.outerHTML;
    }
}

export default DefaultPrepareModel;
